import { useRequest } from "ahooks";
import { API_ENDPOINT } from "@/config/endpoint/endpoint";

export const useFetchAttractions = (category: string = '') => {
  return useRequest(() => API_ENDPOINT.places.getAttractions(category), {
    cacheKey: `attractions-${category}`,
  });
};

export const useFetchAttractionsThemes = () => {
  return useRequest(() => API_ENDPOINT.places.getAttractionsThemes(), {
    cacheKey: `attractions-themes`,
  });
};

export const useFetchAttractionDetail = (id: string) => {
  return useRequest(() => API_ENDPOINT.places.getAttractionDetail(id), {
    cacheKey: `attraction-detail-${id}`,
  });
};